import client_lookup from '@/assets/json/clientLookups.json'
import { useAuthStore } from '@/stores/auth'
import { handleOverride } from './useSchemaOverride'
import lodashSet from 'lodash/set'
/**
 * useSchema to handle dynamic and manual mapping imports
 */
export default async function (serviceId) {
  const authStore = useAuthStore()
  const { application } = client_lookup
  const { applicationId } = authStore.user

  // determine folder name based on user's applicationId
  const [applicationName] = Object.entries(application).find(([_, appId]) => appId == applicationId)

  // the base directory
  const directory = `../library/schema/${applicationName}`
  const overrideDirectory = '../library/schema/common/'
  /**
   * declared list of manual assignments for services.
   * here, you can find services that use the same schema.
   * the original schema that others use do not have to be here
   *
   * example:
   * original schema:               form_788
   * services that use this schema: 789, 790
   * const mapping = {
   *   603: "form_600",
   *   604: "form_600",
   *   789: "form_788",
   *   790: "form_788",
   * }
   */
  const familyBookSchema = {
    582: 'form_587'
  }
  const truckDriversSchema = {
    968: 'form_967',
    969: 'form_967'
  }

  const reportsSchema = {
    447: 'form_446'
  }
  const courtRequest = {
    207: 'form_206',
    208: 'form_206',
    209: 'form_206'
  }

  const establishmentLicenseSchema = {
    8: 'form_4',
    10: 'form_4',
    15: 'form_4',
    17: 'form_4',
    25: 'form_4',
    42: 'form_4',
    46: 'form_4',
    47: 'form_4',
    48: 'form_4',
    49: 'form_4',
    33: 'form_29',
    34: 'form_29',
    98: 'form_95',
    103: 'form_95',
    111: 'form_110',
    112: 'form_110',
    118: 'form_110',
    148: 'form_148',
    149: 'form_142',
    156: 'form_142',
    157: 'form_142',
    158: 'form_142',
    160: 'form_142',
    343: 'form_142',
    344: 'form_142',
    345: 'form_142',
    363: 'form_142',
    364: 'form_142',
    365: 'form_142',
    453: 'form_4',
    458: 'form_4',
    459: 'form_4',
    463: 'form_4',
    482: 'form_4',
    483: 'form_4',
    518: 'form_4',
    637: 'form_4',
    651: 'form_142',
    652: 'form_142',
    653: 'form_142',
    654: 'form_142',
    655: 'form_142',
    744: 'form_750',
    745: 'form_750',
    748: 'form_750',
    749: 'form_750',
    783: 'form_4',
    784: 'form_380',
    837: 'form_380',
    936: 'form_4',
    870: 'form_917',
    949: 'form_4',
    960: 'form_29',
    961: 'form_29',
    1011: 'form_923',
    1049: 'form_380',
    1052: 'form_380'
  }

  const visaSchema = {
    928: 'form_926',
    933: 'form_926',
    950: 'form_926',
    951: 'form_926',
    952: 'form_926',

    633: 'form_632',
    753: 'form_636',

    1006: 'form_1005',
    1007: 'form_1005',
    1008: 'form_1005',
    1009: 'form_1005',
    1010: 'form_1005',

    1105: 'form_1104'
  }

  const gccVisa = {
    42: 'form_41'
  }

  const residency = {
    71: 'form_70',
    122: 'form_121'
  }

  const investigation = {
    212: 'form_495'
  }

  const icaService = {
    503: 'form_502',
    900: 'form_502'
  }
  const gccCitizen = {
    574: 'form_573',
    1057: 'form_79'
  }

  const typingCenterSchema = {
    26: 'form_24',
    27: 'form_24',
    28: 'form_24',
    40: 'form_24',
    43: 'form_24',
    47: 'form_24',
    48: 'form_24',
    50: 'form_24',
    51: 'form_24',
    52: 'form_24',
    53: 'form_24',
    54: 'form_24',
    383: 'form_24',
    413: 'form_24',
    414: 'form_24',
    436: 'form_24',
    639: 'form_24',
    490: 'form_24',
    642: 'form_24',
    644: 'form_24',
    645: 'form_24',
    646: 'form_24',
    647: 'form_24',
    648: 'form_24',
    664: 'form_24',
    666: 'form_24',
    678: 'form_24',
    755: 'form_24',
    757: 'form_24',
    764: 'form_24',
    785: 'form_24',
    926: 'form_24',
    928: 'form_24',
    933: 'form_24',
    950: 'form_24',
    951: 'form_24',
    952: 'form_24',
    963: 'form_24',
    964: 'form_24',
    965: 'form_24',
    973: 'form_24',
    976: 'form_24',
    978: 'form_24',
    994: 'form_24',
    995: 'form_24',
    1005: 'form_24',
    1006: 'form_24',
    1007: 'form_24',
    1008: 'form_24',
    1009: 'form_24',
    1010: 'form_24',
    1041: 'form_24',
    1099: 'form_24',
    1118: 'form_24',

    37: 'form_36',
    38: 'form_36',
    420: 'form_36',
    763: 'form_36',
    1092: 'form_36',

    386: 'form_385',
    387: 'form_385',

    633: 'form_632',
    635: 'form_632',
    636: 'form_632',
    753: 'form_632',
    977: 'form_632',
    1104: 'form_632',
    1105: 'form_632',

    58: 'form_57',
    59: 'form_57',
    89: 'form_57',
    120: 'form_57',
    121: 'form_57',
    122: 'form_57',
    400: 'form_57',
    437: 'form_57',
    438: 'form_57',
    567: 'form_57',
    569: 'form_57',
    641: 'form_57',
    656: 'form_57',
    657: 'form_57',
    658: 'form_57',
    659: 'form_57',
    662: 'form_57',
    665: 'form_57',
    667: 'form_57',
    668: 'form_57',
    679: 'form_57',
    680: 'form_57',
    756: 'form_57',
    758: 'form_57',
    759: 'form_57',
    771: 'form_57',
    773: 'form_57',
    774: 'form_57',
    775: 'form_57',
    776: 'form_57',
    777: 'form_57',
    778: 'form_57',
    916: 'form_57',
    935: 'form_57',
    938: 'form_57',
    943: 'form_57',
    981: 'form_57',
    982: 'form_57',
    987: 'form_57',
    991: 'form_57',
    1018: 'form_57',
    1023: 'form_57',
    1026: 'form_57',
    1031: 'form_57',
    1033: 'form_57',
    1035: 'form_57',
    1042: 'form_57',
    1093: 'form_57',
    1095: 'form_57',
    1100: 'form_57',
    1102: 'form_57',
    1108: 'form_57',
    1110: 'form_57',

    1062: 'form_1123',
    1123: 'form_1123',
    1125: 'form_1123',
    1127: 'form_1123',

    421: 'form_599',
    429: 'form_599',
    515: 'form_599',
    600: 'form_599',
    601: 'form_599',
    602: 'form_599',
    613: 'form_599',
    754: 'form_599',
    768: 'form_599',
    931: 'form_599',
    979: 'form_599',
    983: 'form_599',
    1112: 'form_599',
    1113: 'form_599',

    70: 'form_69',
    71: 'form_69',
    676: 'form_69',
    677: 'form_69',
    681: 'form_69',
    685: 'form_69',
    686: 'form_69',
    687: 'form_69',
    688: 'form_69',
    689: 'form_69',
    690: 'form_69',
    760: 'form_69',
    769: 'form_69',
    820: 'form_69',
    948: 'form_69',
    955: 'form_69',
    959: 'form_69',
    980: 'form_69',
    985: 'form_69',
    989: 'form_69',
    993: 'form_69',
    1044: 'form_69',
    1055: 'form_69',
    1106: 'form_69',
    1097: 'form_69',
    1116: 'form_69',
    423: 'form_69',

    114: 'form_109',
    115: 'form_109',
    119: 'form_109',
    78: 'form_79',
    424: 'form_424',
    1057: 'form_79',
    139: 'form_140',
    141: 'form_140',
    160: 'form_140',
    185: 'form_184',
    200: 'form_184',
    201: 'form_184',
    202: 'form_184',
    203: 'form_184',
    409: 'form_184',
    410: 'form_184',
    193: 'form_192',
    443: 'form_406',
    445: 'form_406',
    412: 'form_411',
    565: 'form_564',
    435: 'form_434',
    607: 'form_447',
    683: 'form_682',
    1028: 'form_905',
    1029: 'form_905',
    1030: 'form_905'
  }

  const mapping = {
    ...truckDriversSchema,
    ...visaSchema,
    ...establishmentLicenseSchema,
    ...residency,
    ...reportsSchema,
    ...familyBookSchema,
    ...investigation,
    ...icaService,
    ...courtRequest,
    ...gccVisa,
    ...gccCitizen,
    ...(applicationId == 2 && typingCenterSchema)
  }

  const directories = [
    {
      path: `${directory}/form_${serviceId}.json`,
      infoMessage: '[useSchema] found using direct import strategy'
    },
    {
      path: `${directory}/${mapping[serviceId]}.json`,
      infoMessage: '[useSchema] found using direct mapping import strategy'
    },
    {
      path: `../library/schema/share/form_${serviceId}.json`,
      infoMessage: '[useSchema] found using shared direct import strategy'
    },
    {
      path: `../library/schema/share/${mapping[serviceId]}.json`,
      infoMessage: '[useSchema] found using shared mapping import strategy'
    }
  ]

  /**
   * import all json schema directory
   * and find the correct path based on application id and service id
   * returns { path: () => import(path) }
   */
  const jsonModules = import.meta.glob(`../library/schema/*/*.json`)

  const findSchema = (path) => {
    const result = Object.entries(jsonModules).find(([modulePath, _]) => modulePath == path)

    if (!result) return null
    const [_, module] = result
    return module
  }

  for (let index = 0; index < directories.length; index++) {
    const pathObj = directories[index]

    let schemaFunc = findSchema(pathObj.path)
    if (schemaFunc) {
      console.info(`${pathObj.infoMessage} ${pathObj.path}`)
      let res = await schemaFunc()
      return handleOverride(res)
    }
  }

  throw new Error(`Unable to find schema for service id ${serviceId}`)
}
